module.exports = __webpack_public_path__ + "fonts/benchnine-v9-latin-regular.2f8265f5.woff";